import React from 'react'
import { useSearchParams } from 'react-router'
import { openModal } from '@core/Components/Modal'
import { store } from '@core/Store'
import { appHistory } from '@core/Utils/routing/history'
import { AppRoutes } from '@core/AppRoutes'
import { SHARE_BLACKBOOK_SEARCH_PARAM } from '@core/Areas/Blackbook/constants'
import { ShareBlackbookIncoming } from './Components/ShareBlackbook'

export const useShareBlackbookIncomingListener = () => {
  const [searchParams] = useSearchParams()

  React.useEffect(() => {
    const shareBlackbookPayload = searchParams.get(SHARE_BLACKBOOK_SEARCH_PARAM)
    if (shareBlackbookPayload) {
      appHistory.replace(AppRoutes.Home)
      const type = shareBlackbookPayload.slice(0, shareBlackbookPayload.indexOf(','))
      const name = shareBlackbookPayload.slice(shareBlackbookPayload.indexOf(',') + 1)
      if (!type || !name) return

      store.dispatch(
        openModal({
          id: shareBlackbookPayload,
          modalComponent: ShareBlackbookIncoming,
          modalComponentProps: { type, name, id: shareBlackbookPayload },
          isDismissable: false,
          position: 'middle',
          cornerStyle: 'round',
        })
      )
      return
    }
  }, [searchParams])
}
